import { memo } from "react";
import { FormattedMessage } from "react-intl";

import { Badge } from "common/core/badge";
import { EmailAges } from "graphql_globals";

const EmailAge = memo(
  ({ emailAge, withBadge = true }: { emailAge?: EmailAges | null; withBadge?: boolean }) => {
    if (!emailAge) {
      return <>--</>;
    }

    let content;
    let kind: "danger" | "warning" | "success";

    switch (emailAge) {
      case EmailAges.EMAIL_AGE_LESS_THAN_180_DAYS:
        kind = "danger";
        content = (
          <FormattedMessage
            id="a6a036e0-5ca1-43c3-9f45-4161b45967e2"
            defaultMessage="Less than 180 days"
          />
        );
        break;
      case EmailAges.EMAIL_AGE_BETWEEN_180_DAYS_AND_1_YEAR:
        kind = "warning";
        content = (
          <FormattedMessage
            id="53d73cf2-179e-4ea2-a91f-4a0291e7d595"
            defaultMessage="Between 180 days and 1 year"
          />
        );
        break;
      case EmailAges.EMAIL_AGE_BETWEEN_1_YEAR_AND_2_YEARS:
        kind = "warning";
        content = (
          <FormattedMessage
            id="fe1de052-0d84-45e4-8972-6625043c3c0e"
            defaultMessage="Between 1 year and 2 years"
          />
        );
        break;
      case EmailAges.EMAIL_AGE_GREATER_THAN_2_YEARS:
        kind = "success";
        content = (
          <FormattedMessage
            id="f49e6eb5-cbc1-4aef-9937-c9e22ea5f8a2"
            defaultMessage="Greater than 2 years"
          />
        );
        break;
      default:
        return <>--</>;
    }

    return withBadge ? <Badge kind={kind}>{content}</Badge> : content;
  },
);

export default EmailAge;
